module.exports = __webpack_public_path__ + "static/img/ticket_nodata.9026460.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ticket_nodata.png
// module id = uw9p
// module chunks = 0